import { css } from "@emotion/react"
import { Checkbox, Heading } from "@planningcenter/doxy-web"
import React from "react"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { Frequency, StripePaymentMethod } from "../types"
import { CurrencyBadge } from "./CurrencyBadge"
import { Loading } from "./Loading"
import { ConfiguredStripePaymentElement } from "./stripe"
import { UnverifiedPaymentMethodAlert } from "./UnverifiedPaymentMethodAlert"

type PaymentMethodSelectorProps = {
  frequency: Frequency
  savePaymentMethodChecked: boolean
  stripePaymentMethod?: StripePaymentMethod
}

// TODO: (if possible) mark this as the focused pane when SPE has been
// interacted with

export function PaymentMethodSelector({
  frequency,
  savePaymentMethodChecked,
  stripePaymentMethod,
}: PaymentMethodSelectorProps) {
  const {
    config: { unverified_payment_methods },
    dispatch,
  } = useDonationFormContext()

  const showSavePaymentMethodCheckbox =
    frequency.type === "once" &&
    !stripePaymentMethod?.id &&
    stripePaymentMethod?.type === "card"

  const handleSavePaymentMethodCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch({
      type: "SET_SAVE_PAYMENT_METHOD_CHECKED",
      savePaymentMethodChecked: event.target.checked,
    })
  }

  return (
    <div>
      <div className="d-f jc-sb">
        <Heading level={3} text="Payment method" />
        <CurrencyBadge />
      </div>

      <UnverifiedPaymentMethodAlert
        paymentMethods={unverified_payment_methods}
      />

      <React.Suspense fallback={<Loading />}>
        <div className="mt-2">
          <ConfiguredStripePaymentElement />
        </div>
      </React.Suspense>
      {showSavePaymentMethodCheckbox && (
        <div
          className="mt-3"
          css={css`
            padding-inline-start: 1.1rem; // align with payment methods above
          `}
        >
          <Checkbox
            id="savePaymentMethodCheckbox"
            checked={savePaymentMethodChecked}
            label="Save this payment method"
            onChange={handleSavePaymentMethodCheckboxChange}
          />
        </div>
      )}
    </div>
  )
}
